import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "profile-menu dropdown" }
const _hoisted_2 = {
  type: "button",
  class: "profile-menu__trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "aria-label": "منوی حساب کاربری"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "bi bi-person-fill profile-menu__icon"
}
const _hoisted_5 = { class: "dropdown-menu profile-menu__dropdown dropdown-menu-end" }
const _hoisted_6 = { class: "profile-menu__header" }
const _hoisted_7 = { class: "profile-menu__name" }
const _hoisted_8 = {
  key: 0,
  class: "profile-menu__phone"
}

import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { resolveAvatarSrc } from "@/constants/avatars";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  setup(__props) {

const router = useRouter();
const { user, logout, init } = useAuth();

const displayName = computed(() => {
  const name = user.value?.full_name?.trim();
  if (name) return name;
  if (typeof user.value?.username === "string" && user.value.username) {
    return user.value.username;
  }
  return "حساب کاربری";
});

const avatarSrc = computed(() =>
  resolveAvatarSrc(
    typeof user.value?.avatar_url === "string" ? user.value.avatar_url : null
  )
);

const initials = computed(() => {
  const name = user.value?.full_name?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
  const handle = typeof user.value?.username === "string" ? user.value.username : "";
  if (handle) return handle.slice(0, 2).toUpperCase();
  return "";
});

function handleLogout() {
  logout();
  router.push("/");
}

onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["profile-menu__avatar", { 'profile-menu__avatar--image': !!avatarSrc.value }]),
        "aria-hidden": "true"
      }, [
        (avatarSrc.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: avatarSrc.value,
              alt: "",
              class: "profile-menu__avatar-img"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!initials.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(initials.value), 1)
                  ], 64))
            ], 64))
      ], 2)
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(displayName.value), 1),
        (_unref(user)?.username)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "@" + _toDisplayString(_unref(user).username), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("li", null, [
        _createElementVNode("hr", { class: "dropdown-divider" })
      ], -1)),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item profile-menu__item",
          to: "/profile"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "bi bi-person" }, null, -1),
            _createTextVNode(" پروفایل ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item profile-menu__item",
          to: "/settings"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "bi bi-gear" }, null, -1),
            _createTextVNode(" تنظیمات ", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("li", null, [
        _createElementVNode("hr", { class: "dropdown-divider" })
      ], -1)),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          type: "button",
          class: "dropdown-item profile-menu__item profile-menu__item--logout",
          onClick: handleLogout
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1),
          _createTextVNode(" خروج ", -1)
        ]))])
      ])
    ])
  ]))
}
}

})